import { Card, Empty, Typography } from "antd";
import { Pie } from "@ant-design/plots";
import { useQuery } from "@apollo/client";

import { ENDPOINT_RPC_REGION_METRICS_QUERY } from "../../helpers/graphql/endpoint";

export function EndpointRegionMetrics({ project, network, chain, archive, showLast, height }: any) {
  const { loading, data } = useQuery(ENDPOINT_RPC_REGION_METRICS_QUERY, {
    variables: { projectId: project.id, network, chain, archive, showLast },
  });

  const endpointMetricsByRegion =
    data?.endpointMetricsByRegion?.length > 0 ? data?.endpointMetricsByRegion : null;

  const config = {
    angleField: "count",
    colorField: "group",
    data: endpointMetricsByRegion,

    appendPadding: 10,
    radius: 1,
    tooltip: {
      formatter: ({ group, count }: any) => {
        return {
          name: group,
          value: Intl.NumberFormat("en-US", {
            notation: "compact",
            maximumFractionDigits: 1,
          }).format(count),
        };
      },
    },
    label: {
      type: "outer",
      content: "{name} {percentage}",
    },
    interactions: [
      {
        type: "pie-legend-active",
      },
      {
        type: "element-active",
      },
    ],
  };

  return loading ? (
    <Card loading={true} className="card-loading" />
  ) : (
    <Card className={"card-body"} title="Request by region">
      <Typography.Text style={{ color: "grey" }}></Typography.Text>

      {endpointMetricsByRegion ? (
        <Pie {...config} height={height} />
      ) : (
        <Empty style={{ height: height }} />
      )}
    </Card>
  );
}
